import React from "react"

export default function Hjem() {
    return (
        <div>
            <header className="frontResidencen">
                <h1 className="headerTitle">RESIDENCEN</h1>
                <p className="headerParagraph">Nerja · España</p>
            </header>
            <div className="frontDark vaermelding">
                <h1>Værmelding</h1>
                <p>Neste dager i Nerja</p>
                <div className="vaerRamme">
                    <embed
                        type="text/html"
                        src="https://www.yr.no/en/content/2-2513240/meteogram.svg"
                    />
                </div>
            </div>
        </div>
    )
}
